// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBbd87dFhJWtcNVcsGIvPpJ8rrwwgKwNj4",
  authDomain: "portfolio-ikshvaku.firebaseapp.com",
  projectId: "portfolio-ikshvaku",
  storageBucket: "portfolio-ikshvaku.firebasestorage.app",
  messagingSenderId: "639003547674",
  appId: "1:639003547674:web:092a8854fb82e4329999a3",
  measurementId: "G-X7LQZ1418R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app); export { db };

